module.exports = __webpack_public_path__ + "static/media/Asset 8.5442afc3.svg";